<div class="next-send-offer">
  <div class="next-send-offer__label">
    <span>{{ 'HEADER.SEND_OFFER.LABEL' | translate }}</span>
    <img src="./assets/images/icons/mail.svg" alt="Mail offer">
  </div>

  <div class="next-send-offer__button">
    <button class="btn btn--small"
            (click)="mailOffer()">
      {{ buttonLabel | translate }}
    </button>
  </div>
</div>
